import { CurrentUserDto } from '../types/UserDtos';
import { getCurrentUser } from './react/services/CurrentUser';
import { hasBasicHr, isAdmin } from './react/services/User';
import * as R from './routes';

const routePairsForHr = {
    [R.YOUR_SURVEYS_SHARED]: R.ADMIN_SURVEYS,
    [R.YOUR_SURVEYS_SHARED_WITH_SURVEY]: R.ADMIN_SURVEYS_WITH_SURVEY,
    [R.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT]: R.ADMIN_SURVEYS_WITH_SURVEY_PRINT,
    [R.OBJECTIVES_COMPANY_CYCLES]: R.ADMIN_OBJECTIVES_SELECT_CYCLE,
    [R.OBJECTIVES_COMPANY_CYCLE]: R.ADMIN_OBJECTIVES_CYCLE_OVERVIEW,
};

const routePairsForTech = {
    // tech admins have access to
    [R.PEOPLE_DIRECTORY]: R.ADMIN_USERS_DIRECTORY,
};

const routePairsAll = { ...routePairsForHr, ...routePairsForTech };

const getRoutePairsForUser = (user: CurrentUserDto): Partial<typeof routePairsAll> => {
    if (hasBasicHr(user)) {
        return routePairsAll;
    } else if (isAdmin(user)) {
        return routePairsForTech;
    } else {
        return {};
    }
};

export const getAdminRouteForNavigation = (oldRoute: keyof typeof routePairsAll) => {
    return getAdminRouteForNavigationForUser(getCurrentUser(), oldRoute);
};

export const getAdminRouteForNavigationForUser = (user: CurrentUserDto, oldRoute: keyof typeof routePairsAll) => {
    const newRoute = getRoutePairsForUser(user)[oldRoute];

    return newRoute ?? oldRoute;
};

export const getRedirectsForHR = () => {
    const user = getCurrentUser();

    const newNavRedirects = Object.entries(getRoutePairsForUser(user));

    return newNavRedirects;
};
